<template>

</template>

<script>
  import 'jquery-validation'
  
  export default {
    name: 'RegisterEthicCourse',
    mounted () {
      const $form = $('.form')
      
      /**
       * Init JQuery validation
       */
      $(() => {
        $form.validate({
          ignore: [],
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            label.addClass('invalid-feedback')
            label.insertAfter(element)
          },
          rules: {
            title: {
              required: true,
              maxlength: 255,
            },
            institution_id: {
              required: true,
            },
          },
          messages: {
            title: {
              required: 'Este campo es requerido.',
              maxlength: 'El texto no debe superar los 255 caracteres.',
            },
            institution_id: {
              required: 'Seleccione una opción',
            },
          },
          submitHandler (form) {
            $('#btn-save, #btn-cancel').prop('disabled', true)
            $('#btn-save').find('.spinner-border').removeClass('d-none')
            
            form.submit()
          },
        })
        
        $form.removeClass('invisible')
      })
    },
  }
</script>
